import { useState } from "react";
import Input from "../input/input";
import OutsideClickHandler from 'react-outside-click-handler';
import ListItem from "./ListItem";
import debounce from "lodash/debounce";
import "./search.scss";

const Search = ({
  form,
  value,
  name,
  placeholder,
  onSearch,
  searchResults,
  rightIconClass,
  onClickRightIcon,
  onSelectItem,
  autoComplete,
  autoFocus,
  invalid,
  updateParentValue,
  isDisabled
}) => {
  const [showResults, setShowResults] = useState(false);
  const [cursor, setCursor] = useState(-1)

  const handleChange = (value) => {
    onSelectItem(false);
    form.setFieldValue(name, value);
    form.setTouched({
      ...form.touched,
      [name]:true
    })
    setShowResults(true);
    debouncedSearch(value);
  };

  const debouncedSearch = debounce((value) => {
    onSearch(value);
  }, 500);

  const handleSelect = (value) => {
    form.setFieldValue(name, value);
    updateParentValue(value);
    onSelectItem(true);
    setShowResults(false);
    setCursor(-1);
  };

  const handleOnBlur = () => {
    if(searchResults.indexOf(value) > -1){
      setShowResults(false);
      onSelectItem(true);
      setCursor(-1);
    }
    updateParentValue(value);
  }

  const handleOnKeyDown = (event) => {
    if (!showResults) {
      setShowResults(true);
    }
    if (event.keyCode === 38 && cursor > -1) {
      setCursor(prevCursor => prevCursor - 1);
    } else if (event.keyCode === 40 && cursor < searchResults?.length - 1) {
      setCursor(prevCursor => (prevCursor + 1))
    } else if( event.keyCode === 13 && cursor > -1 && cursor < searchResults?.length) {
      event.preventDefault();
      handleSelect(searchResults[cursor]);
    } else if (event.keyCode === 13) {
      event.preventDefault();
    }
  }

  return (
    <div className="glu-search">
      <div className="glu-search-input">
        <Input
          name={name}
          value={value}
          autoFocus={autoFocus}
          autoComplete={autoComplete}
          onChange={handleChange}
          placeholder={placeholder}
          suffixIcon={rightIconClass}
          onSuffixClick={onClickRightIcon}
          invalid={invalid}
          onFocusChange={handleOnBlur}
          onKeyDown={handleOnKeyDown}
          isDisabled={isDisabled}
        />
      </div>
      {showResults && (
        <OutsideClickHandler onOutsideClick={() => setShowResults(false)} >
          <div className="glu-search-results">
            {searchResults.map((searchItem, index) => (
              <ListItem
                key={`${index}-${searchItem}`}
                active={cursor === index}
                onClickItem={handleSelect}
                text={searchItem}
              />
            ))}
          </div>
        </OutsideClickHandler>
      )}
    </div>
  );
};

export default Search;
